import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue";
const _hoisted_1 = { class: "mobile-footer-componenet tw-bg-red" };
const _hoisted_2 = { class: "" };
const _hoisted_3 = { class: "tw-flex tw-w-full tw-justify-between" };
const _hoisted_4 = ["src", "alt"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_router_link = _resolveComponent("router-link");
    return (_openBlock(), _createElementBlock("header", _hoisted_1, [
        _createElementVNode("nav", _hoisted_2, [
            _createElementVNode("ul", _hoisted_3, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.navLinks, (link) => {
                    return (_openBlock(), _createElementBlock("li", {
                        key: link.label,
                        class: "tw-text-white tw-flex-col tw-w-full tw-flex tw-justify-center tw-items-center"
                    }, [
                        _createVNode(_component_router_link, {
                            to: link.to
                        }, {
                            default: _withCtx(() => [
                                _createElementVNode("img", {
                                    src: link.img,
                                    alt: link.img,
                                    class: "tw-mx-auto"
                                }, null, 8, _hoisted_4),
                                _createElementVNode("p", {
                                    class: _normalizeClass(["tw-font-semibold tw-text-[11px] tw-bg-transparent tw-px-0 tw-w-full nav-link tw-text-center", {
                                            '!tw-text-[#FFAB20]': _ctx.isActive(link.route),
                                            '!tw-text-white': !_ctx.isActive(link.route),
                                        }])
                                }, _toDisplayString(link.label), 3)
                            ]),
                            _: 2
                        }, 1032, ["to"])
                    ]));
                }), 128))
            ])
        ])
    ]));
}
